@if (question?.cent_aq_question_type_id === QuestionType.checkbox_slider) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group '"
    >
    <app-question-checkbox-slider
      [question]="question"
      [sliderMin]="question?.min_val"
      [sliderMax]="question?.max_val"
      [sliderInit]="question?.answer"
      [sliderStep]="question?.interval"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-checkbox-slider>
  </div>
}

<!-- Radio button -->
@if (question?.cent_aq_question_type_id === QuestionType.radio) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group '"
    >
    <app-question-radio
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-radio>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.mini_form) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group '"
    >
    <app-question-mini-form
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-mini-form>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.yes_no) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group '">
    <app-question-yes-no
      [question]="question"
      [readOnly]="readonly"
      [showLabel]="false"
      (questionAnswer)="questionAnswerController($event)"
      >
    </app-question-yes-no>
  </div>
}
<!--Question Slider-->
@if (showParent
  && (question?.cent_aq_question_type_id === QuestionType.slider_si
  || question?.cent_aq_question_type_id === QuestionType.slider_excess)) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-slider-parent
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showHeader]="question?.cent_aq_question_type_id === QuestionType.slider_excess"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-slider-parent>
  </div>
}

<!-- Slider -->
@if (!showParent
  && (question?.cent_aq_question_type_id === QuestionType.slider_si
  || question?.cent_aq_question_type_id === QuestionType.slider_excess)) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-slider
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-slider>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.slider_generic) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-slider-generic
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-slider-generic>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.start_end_date) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-multiple-date-picker
      [question]="question"
      [numberMonths]="1"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-multiple-date-picker>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.textbox
  || question?.cent_aq_question_type_id === QuestionType.passport
  || question?.cent_aq_question_type_id === QuestionType.id_number
  || question?.cent_aq_question_type_id === QuestionType.other_id_number) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'">
    <app-question-textbox
      [question]="question"
      [readOnly]="question?.edit === 0"
      [editModal]="question?.isEdit"
      [showLabel]="showLabel"
      [showToolTip]="question?.edit === 0"
      [toolTipContent]="question?.question_bubble"
    [isIdInput]="question?.cent_aq_question_type_id === QuestionType.id_number
    || question?.cent_aq_question_type_id === QuestionType.other_id_number"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-textbox>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.year) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-year
      [question]="question"
      [readOnly]="question?.edit === 0"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-year>
  </div>
}

<!--Question Tel-->
@if (question?.cent_aq_question_type_id === QuestionType.tel) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-tel
      [question]="question"
      [showLabel]="showLabel"
      [readOnly]="question?.edit === 0"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-tel>
  </div>
}

<!--Question Company Registration Input-->
@if (question?.cent_aq_question_type_id === QuestionType.registration_number) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group '"
    >
    <app-question-company-registration
      [question]="question"
      [showLabel]="showLabel"
      [readOnly]="question?.edit === 0"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-company-registration>
  </div>
}

<!--Question Select Button-->
@if (question?.cent_aq_question_type_id === QuestionType.select_button) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-select-button
      [readonly]="question?.edit === 0"
      [question]="question"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-select-button>
  </div>
}

<!--Question Toggle Button-->
@if (question?.cent_aq_question_type_id === QuestionType.toggle) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-toggle-button
      [question]="question"
      [showLabel]="showLabel"
      [readonly]="question?.edit === 0"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-toggle-button>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.plus_minus) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group '"
    >
    <app-question-plus-minus
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-plus-minus>
  </div>
}

<!--Question Product Select-->
@if (question?.cent_aq_question_type_id === QuestionType.product_select) {
  <app-question-product-select
    [question]="question" [editModal]="true" (questionAnswer)="questionAnswerController($event)">
  </app-question-product-select>
}

@if (question?.cent_aq_question_type_id === QuestionType.textarea) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-textarea
      [question]="question"
      [showLabel]="showLabel"
      [editModal]="question?.isEdit"
      [readonly]="question?.edit === 0"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-textarea>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.family_list
  || question?.cent_aq_question_type_id === QuestionType.allrisk_list
  || question?.cent_aq_question_type_id === QuestionType.list
  || question?.cent_aq_question_type_id === QuestionType.vehicle_list) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-items-list
      #childRiskList
      [question]="question"
      [itemQuestions]="childItemQuestions"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-items-list>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.toggle_parent) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-toggle-parent
      [question]="question"
      [itemQuestions]="childItemQuestions"
      [showParent]="showParent"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-toggle-parent>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.currency
  || question?.cent_aq_question_type_id === QuestionType.currency_readonly) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'">
    <app-question-currency
      [question]="question"
      [showLabel]="showLabel"
      [isEditModal]="isEditModal"
      [readOnly]="question?.cent_aq_question_type_id === QuestionType.currency_readonly || question?.edit === 0"
      [showLabelQuestionCopy]="showLabelQuestionCopy"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-currency>
  </div>
}

<!--Question Min Max Textbox-->
@if (question?.cent_aq_question_type_id === QuestionType.min_max_textbox) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-min-max-textbox
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      (hasError)="questionHasError.emit($event)"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-min-max-textbox>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.address) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-address
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-address>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.address_textbox) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-address-textbox
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-address-textbox>
  </div>
}


@if (question?.cent_aq_question_type_id === QuestionType.vehicle_make ||
  question?.cent_aq_question_type_id === QuestionType.vehicle_model ||
  question?.cent_aq_question_type_id === QuestionType.vehicle_year ||
  question?.cent_aq_question_type_id === QuestionType.profession ||
  question?.cent_aq_question_type_id === QuestionType.industry) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group '"
    >
    <app-question-autocomplete
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-autocomplete>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.autocomplete_generic) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group '"
    >
    <app-question-autocomplete-generic
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-autocomplete-generic>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.verify_email) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group '"
    >
    <app-question-verify-email
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-verify-email>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.vehicle_details) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group '"
    >
    <app-question-vehicle-make-year-model
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      [isEdit]="isEditModal"
      [evi]="evi"
      [showToolTip]="question?.edit === 0"
      [toolTipContent]="'To change this answer you need to restart or contact us'"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-vehicle-make-year-model>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.reg_vin) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group '"
    >
    <app-question-reg-vin
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      [isEdit]="isEditModal"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-reg-vin>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.label_amount_parent ||
  question?.cent_aq_question_type_id === QuestionType.label_perc_parent ||
  question?.cent_aq_question_type_id === QuestionType.textbox_amount_parent ||
  question?.cent_aq_question_type_id === QuestionType.textbox_perc_parent) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group '"
    >
    <app-question-label-textbox-parent
      [question]="question"
      [showFooterTotal]="false"
      [showHeaderTotal]="false"
      [showDelete]="false"
      [showParent]="showParent"
      [itemQuestions]="childItemQuestions"
    [isPercentage]="question?.cent_aq_question_type_id === QuestionType.label_perc_parent ||
  question?.cent_aq_question_type_id === QuestionType.textbox_perc_parent"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-label-textbox-parent>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.label_amount) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-label-amount
      [question]="question"
      [showDelete]="false"
      [showToolTip]="false"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-label-amount>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.or_control) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-or-control
      [question]="question"
      [showDelete]="false"
      [showToolTip]="false"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-or-control>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.label_perc) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-label-percentage
      [question]="question"
      [showDelete]="false"
      [showToolTip]="false"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-label-percentage>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.textbox_amount) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-textbox-amount
      [question]="question"
      [showDelete]="false"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-textbox-amount>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.textbox_perc) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-textbox-percentage
      [question]="question"
      [showDelete]="false"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-textbox-percentage>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.generic_parent_stacked) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group ui-front form-group--lg'">
    <app-question-generic-parent-stacked [question]="question" [itemQuestions]="childItemQuestions" (questionAnswer)="questionAnswerController($event)">
    </app-question-generic-parent-stacked>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.uw_modal) {
  <div>
    <app-question-uw-modal [question]="question" (questionAnswer)="questionAnswerController($event)">
    </app-question-uw-modal>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.csv_upload) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-csv-upload
      [question]="question"
      [readOnly]="question?.edit === 0"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-csv-upload>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.dropdown) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group ui-front form-group--lg'">
    <app-question-dropdown
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      [showQuestionCopyLabel]="showLabelQuestionCopy"
      [selectedValue]="question?.answer"
      [isEditModal]="isEditModal"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-dropdown>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.multi_dropdown_perc) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group ui-front form-group--lg'">
    @if (question?.cent_aq_question_type_id === QuestionType.multi_dropdown_perc) {
      <app-question-multi-dropdown-perc
        [question]="question" [showHeader]="true" [showHeaderTotal]="false" [showFooterTotal]="false"
        [showDelete]="true" (questionAnswer)="activateNextButton($event)">
      </app-question-multi-dropdown-perc>
    }
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.funeral_policy_member) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group ui-front form-group--lg'">
    <app-question-funeral-policy-member
      [showHeader]="true" [showHeaderTotal]="false"
      [question]="question"
      [childItemQuestions]="funeralMemberQuestions"
      [showFooterTotal]="false" [showDelete]="false"
      (questionAnswer)="activateNextButton($event)">
    </app-question-funeral-policy-member>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.dropdown_currency) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group form-group--lg'">
    <app-question-dropdown-currency
      [question]="question"
      [readOnly]="question?.edit === 0"
      [showLabel]="showLabel"
      [isEditModal]="isEditModal"
      [selectedValue]="question?.answer"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-dropdown-currency>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.items_specify) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-items-specify
      [question]="question"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-items-specify>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.date) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group form-group--lg'"
    >
    <app-question-date-picker
      [question]="question"
      [showLabel]="showLabel"
      [numberMonths]="1"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-date-picker>
  </div>
}

<!--Question Time Picker-->
@if (question?.cent_aq_question_type_id === QuestionType.time) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group form-group--lg'"
    >
    <app-question-timepicker
      [showLabel]="showLabel"
      [question]="question"
      [noShadow]="isEditModal"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-timepicker>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.dob) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group form-group--lg'">
    <app-question-date-of-birth
      [question]="question"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-date-of-birth>
  </div>
}


@if (question?.cent_aq_question_type_id === QuestionType.multiselect
  || question?.cent_aq_question_type_id === QuestionType.checkbox) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-checkbox-multiple
      [question]="question"
      [showLabel]="showLabel"
      [readOnly]="question?.edit === 0"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-checkbox-multiple>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.radio_column_parent) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-radio-column-parent
      [showLabel]="showLabel"
      [question]="question"
      [showParent]="showParent"
      [itemQuestions]="childItemQuestions"
      (parentQuestionAnswer)="questionAnswerController($event)">
    </app-question-radio-column-parent>
  </div>
}


@if (question?.cent_aq_question_type_id === QuestionType.pills) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-pill-buttons
      [question]="question"
      [isRadio]="false"
      [showLabel]="false"
      [isUploadPills]="true"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-pill-buttons>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.multiselect_items) {
  <app-question-multiselect-items
    [question]="question"
    [readonly]="question?.edit === 0"
    (questionAnswer)="questionAnswerController($event)">
  </app-question-multiselect-items>
}

@if (question?.cent_aq_question_type_id === QuestionType.selector) {
  <app-question-selector
    [question]="question"
    (questionAnswer)="questionAnswerController($event)">
  </app-question-selector>
}

@if (question?.cent_aq_question_type_id === QuestionType.odometer_reading) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-odometer-reading
      [question]="question"
      [readOnly]="question?.edit === 0"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-odometer-reading>
  </div>
}

<!-- <div
[class]="controlCssClass ? controlCssClass : 'form-group'"
*ngIf="question?.cent_aq_question_type_id === QuestionType.start_end_date">
<app-question-multiple-date-picker
  [question]="question"
  [numberMonths]="1"
  (questionAnswer)="questionAnswerController($event)">
</app-question-multiple-date-picker>
</div> -->

@if (question?.cent_aq_question_type_id === QuestionType.vehicle_damage_images) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-images-of-damage
      [showSkip]="showSkip"
      [showNarrowCompletedItems]="damageModalNarrow"
      [question]="question"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-images-of-damage>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.uploader_variation_one) {
  <app-question-uploader-variation-one
    [question]="question"
    [showNoShadow]="damageModalNarrow"
    (questionAnswer)="questionAnswerController($event)">
  </app-question-uploader-variation-one>
}

@if (question?.cent_aq_question_type_id === QuestionType.parent_question_variation_one) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    @if (question?.cent_aq_question_type_id === QuestionType.parent_question_variation_one) {
      <app-question-parent-variation-one
        [question]="question"
        [showLabel]="false"
        [showParent]="false"
        (questionAnswer)="questionAnswerController($event)">
      </app-question-parent-variation-one>
    }
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.parent_question_variation_two) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    @if (question?.cent_aq_question_type_id === QuestionType.parent_question_variation_two) {
      <app-question-parent-variation-two
        [question]="question"
        (parentQuestionAnswer)="questionAnswerController($event)">
      </app-question-parent-variation-two>
    }
  </div>
}



@if (question?.cent_aq_question_type_id === QuestionType.number) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-number-textbox
      [question]="question"
      [showLabel]="showLabel"
      [readOnly]="question?.edit === 0"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-number-textbox>
  </div>
}
@if (question?.cent_aq_question_type_id === QuestionType.email) {
  <div
    [class]="controlCssClass ? controlCssClass : 'form-group'"
    >
    <app-question-email
      [question]="question"
      [showLabel]="showLabel"
      [readOnly]="question?.edit === 0"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-email>
  </div>
}

<!--<div
[class]="controlCssClass ? controlCssClass : 'form-group'"
*ngIf="question?.cent_aq_question_type_id === QuestionType.number">
<app-question-textbox-icon
  [question]="question"
    [readOnly]="question?.cent_aq_question_type_id === QuestionType.id_number
    || question?.cent_aq_question_type_id === QuestionType.passport || question?.edit === 0"
  [showLabel]="true"
  [isIdInput]="question?.cent_aq_question_type_id === QuestionType.id_number"
  (questionAnswer)="questionAnswerController($event)">
</app-question-textbox-icon>
</div>-->

<!--Question Radio Image-->
@if (question?.cent_aq_question_type_id === QuestionType.radio_icon) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group form-group-lg'"
    >
    <app-question-radio-icons
      [question]="question"
      [showLabel]="showLabel"
      [readOnly]="question?.edit === 0"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-radio-icons>
  </div>
}

<!--Question Radio Image-->
@if (question?.cent_aq_question_type_id === QuestionType.radio_image) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group form-group-lg'"
    >
    <app-question-radio-image-details
      [question]="question"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-radio-image-details>
  </div>
}

<!--Question uploader-->
@if (question?.cent_aq_question_type_id === QuestionType.upload) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group form-group-lg'"
    >
    <app-question-upload
      [labelText]="question?.question_copy"
      [showLabel]="showLabel"
      [showNoteText]="showUploaderNoteText"
      [showUploadLabelText]="showUploaderLabelText"
      [uploadLabelText]="uploaderLabelText"
      [noteText]="uploaderNoteText"
      [question]="question"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-upload>
  </div>
}

<!--Question uploader-->
@if (question?.cent_aq_question_type_id === QuestionType.upload_images) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group form-group-lg'"
    >
    <app-question-uploaders-images
      [labelText]="question?.question_copy"
      [question]="question"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-uploaders-images>
  </div>
}

<!--Question uploader-->
@if (question?.cent_aq_question_type_id === QuestionType.upload_videos) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group form-group-lg'"
    >
    <app-question-uploaders-videos
      [labelText]="question?.question_copy"
      [question]="question"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-uploaders-videos>
  </div>
}

<!--Question uploader-->
@if (question?.cent_aq_question_type_id === QuestionType.upload_selfie) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group form-group-lg'"
    >
    <app-question-uploaders-selfie
      [labelText]="question?.question_copy"
      [question]="question"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-uploaders-selfie>
  </div>
}

<!--Question uploader-->
@if (question?.cent_aq_question_type_id === QuestionType.upload_documents) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group form-group-lg'"
    >
    <app-question-uploaders-documents
      [labelText]="question?.question_copy"
      [question]="question"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-uploaders-documents>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.parent_question_variation_one) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group form-group-lg'"
    >
    <app-question-parent-variation-one
      [showParent]="showParent"
      [itemQuestions]="childItemQuestions"
      [showLabel]="showLabel"
      [question]="question"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-parent-variation-one>
  </div>
}

@if (question?.cent_aq_question_type_id === QuestionType.parent_question_variation_two) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group form-group-lg'"
    >
    <app-question-parent-variation-two
      [question]="question"
      (parentQuestionAnswer)="questionAnswerController($event)">
    </app-question-parent-variation-two>
  </div>
}

<!--Question Location-->
@if (question?.cent_aq_question_type_id === QuestionType.location) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group form-group-lg'"
    >
    <app-question-location
      [question]="question"
      [showLabel]="showLabel"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-location>
  </div>
}

<!--Question Witness Details-->
@if (question?.cent_aq_question_type_id === QuestionType.witness_details) {
  <div [class]="controlCssClass ? controlCssClass : 'form-group form-group-lg'"
    >
    <app-question-witness-details
      [question]="question"
      [showSkip]="showSkip"
      [readonly]="readOnly"
      (questionAnswer)="questionAnswerController($event)">
    </app-question-witness-details>
  </div>
}


<!--Vaps Controls-->
@if (question?.cent_aq_question_type_id === QuestionType.vaps_funeral_1) {
  <app-vaps-funeral-one
    [question]="question"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [currentVap]="vap"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    [productId]="product_id"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-funeral-one>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_funeral_2) {
  <app-vaps-funeral-two
    [question]="question"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [currentVap]="vap"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    [productId]="product_id"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-funeral-two>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_funeral_3) {
  <app-vaps-funeral-three
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    [productId]="product_id"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-funeral-three>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_general_1) {
  <app-vaps-general-one
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [addAddons]="addAddons"
    [productId]="product_id"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-general-one>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_general_2) {
  <app-vaps-general-two
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [productId]="product_id"
    [addAddons]="addAddons"
    [sessionId]="session_details?.session_id"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-general-two>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_general_3) {
  <app-vaps-general-three
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-general-three>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_general_4) {
  <app-vaps-general-four
    [question]="question"
    [currentVap]="vap"
    [sessionId]="session_details?.session_id"
    [collation_vaps]="collation_vaps"
    [collations]="collations"
    [addAddons]="addAddons"
    [productId]="product_id"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-general-four>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_general_5) {
  <app-vaps-general-five
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAnother]="addAnother"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAnotherChanged)="setAddAnother($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-general-five>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_general_6) {
  <app-vaps-general-six
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAnother]="addAnother"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAnotherChanged)="setAddAnother($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-general-six>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_general_7) {
  <app-vaps-general-seven
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-general-seven>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_general_8) {
  <app-vaps-general-eight
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-general-eight>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_general_9) {
  <app-vaps-general-nine
    [question]="question"
    [addAnother]="addAnother"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAnotherChanged)="setAddAnother($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-general-nine>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_general_10) {
  <app-vaps-general-ten
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAnother]="addAnother"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAnotherChanged)="setAddAnother($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-general-ten>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_general_11) {
  <app-vaps-general-eleven
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAnother]="addAnother"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAnotherChanged)="setAddAnother($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-general-eleven>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_vehicle_1) {
  <app-vaps-vehicle-one
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-vehicle-one>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_vehicle_4) {
  <app-vaps-vehicle-four
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    [productId]="product_id"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-vehicle-four>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_vehicle_5) {
  <app-vaps-vehicle-five
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-vehicle-five>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_location_1) {
  <app-vaps-location-one
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-location-one>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_location_2) {
  <app-vaps-location-two
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-location-two>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_location_3_buildings) {
  <app-vaps-location-three-buildings
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [productId]="product_id">
  </app-vaps-location-three-buildings>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_location_3_contents) {
  <app-vaps-location-three-contents
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-location-three-contents>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_location_4) {
  <app-vaps-location-four
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    [productId]="product_id"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-location-four>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_location_5) {
  <app-vaps-location-five
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-location-five>
}

@if (question?.cent_aq_question_type_id === QuestionType.vaps_location_6) {
  <app-vaps-location-six
    [question]="question"
    [currentVap]="vap"
    [collations]="collations"
    [collation_vaps]="collation_vaps"
    [productId]="product_id"
    [sessionId]="session_details?.session_id"
    [addAddons]="addAddons"
    (amountChanged)="amountChanged.emit($event)"
    (addAddonsChanged)="setAddAddon($event)">
  </app-vaps-location-six>
}

@if (question?.cent_aq_question_type_id === QuestionType.interstitial_variation_one) {
  <div class="question-stepper">
    <div class="question-stepper__img question-stepper__img--avatar">
      <img [src]="'assets/' + session_details?.category_id + '/avatar/happy.png'" class="icon" alt=""/>
    </div>
    <div class="question-stepper__content">
      <h3 class="font-normal" [innerHTML]="question?.question_copy">
      </h3>
    </div>
  </div>
  <app-question-interstitial-variation-one [question]="question"></app-question-interstitial-variation-one>
}



